import React from "react";

import { Button, Table, Alert, Col, Row } from "react-bootstrap";
import pdf from "../../../resources/media/pdf.gif";
import chevronDown from "../../../resources/media/chevron-down.svg";
import { getIsLateClass } from "../components/common";
import {
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	DOCKETS_SEARCH_FOR_OPTION,
	SERVICE_LIST_SEARCH_FOR_OPTION,
	SEARCH_FOR_ASSOCIATED_DATA_TYPE,
	MAX_SEARCH_LIMIT,
	RECORDATIONS_SEARCH_FOR_OPTION,
	RECORDATION_PARTIES_SEARCH_FOR_OPTION,
	DOCKET_DATA_TYPE,
	BY_DATE_SEARCH_FOR_OPTION,
	RECORDATION_DATA_TYPE,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION,
	ALL_DOCUMENTS_SEARCH_FOR_OPTION,
	ALL_DOCUMENTS_DATA_TYPE
} from "../../../resources/constants/searches";
import {
	DATA_TYPE_FIELD,
	DOCKET_NUM_FIELD,
	DOCKET_NUM_PART_ONE_NAME,
	DOCKET_NUM_PART_TWO_NAME,
	DOCKET_NUM_PART_THREE_NAME,
	DOCKET_NUM_PART_FOUR_NAME,
	SERVICE_LIST_FIELD,
	SERVICE_LIST_TEXT,
	DECISION_ATTACHMENT_FIELD,
	FILING_DATE_FIELD,
	FILING_ATTACHMENT_FIELD,
	RECORDATION_CATEGORY_FIELD,
	PARTY_TYPE_FIELD,
	ADDRESS_FIELD,
	ADDRESS_LINE_ONE_FIELD,
	ADDRESS_LINE_TWO_FIELD,
	ADDRESS_CITY_FIELD,
	ADDRESS_STATE_FIELD,
	ADDRESS_COUNTRY_FIELD,
	ADDRESS_ZIP_FIELD,
	ADDRESS_TEL_FIELD,
	ADDRESS_FAX_FIELD,
	RESULT_HEADERS,
	RESULT_FIELDS,
	BY_DATE_RESULT_HEADERS,
	RETURN_TO_SEARCH_TEXT,
	SEARCH_FOR_NAME,
	BY_DATE_RESULT_FIELDS,
	MAILING_LABELS_TEXT,
	SERVICE_DATE_FIELD,
	OFFICIAL_FILING_DATE_FIELD,
	DOCKET_NUM_LABEL,
	SERVICE_LIST_HEADER,
	FILED_BY_FIELD,
	DOCKETS_LABEL,
    PARTIES_LABEL,
    CENTERED_RESULT_COLUMNS,
	RECORDATION_NUM_FIELD,
	RECORDATION_TYPE_LABEL,
	RECORDATION_TYPE_OF_AGREEMENT_FIELD,
	RECORDATION_HAC_FIELD,
	RECORDATION_HAC_LABEL,
	RECORDATION_NUMBER_LABEL,
	RECORDATION_DATE_OF_AGREEMENT_FIELD,
	OFFICIAL_FILING_DATE_LABEL,
	RECORDATION_EQUIPMENT_DESCRIPTION_FIELD,
	RECORDATION_EQUIPMENT_DESCRIPTION_LABEL,
	RECORDATION_DOCUMENT_LABEL,
	SUBMITTER_HEADER,
	SUBMITTER_FIELD,
	COMPANY_FIELD,
	RECORDATION_PARTY_ID_FIELD,
	OTHER_PARTY_TYPE_FIELD,
	RECORDATION_ATTACHMENT_FIELD,
	DOCUMENT_NAME_FIELD,
	RECORDATION_SUFFIX_NAME,
	RECORDATION_CROSS_REFERENCE_NUMBERS,
	RECORDATION_CROSS_REFERENCE_IDS,
	EQUIPMENT_DESCRIPTION_FIELD,
	RECORDATION_PARTY_NAME,
	RETURN_TO_RESULTS_TEXT,
	RECORDATION_DATE_OF_AGREEMENT_LABEL,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_ATTACHMENT_FIELD,
	ENVCOM_COMMENTS_FIELD,
	ENVCOM_LOCATION_FIELD,
	ENVCOM_SUBMITTER_FIELD,
	ENVCOM_RECIPIENT_FIELD,
	ENVCOM_DATE_RECEIVED_FIELD,
	ENVCOM_DATE_OF_LETTER_FIELD,
	ENVCOM_DATE_FIELD,
	ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD,
	BY_DATE_LABELS,
	DOCKET_ASSOCIATED_LABELS,
	ATTACHMENT_FIELD,
	ALL_DOCUMENTS_DATE_FIELD,
	DOCUMENT_TYPE_FIELD,
	ALL_DOCUMENTS_DECISION_RED_TEXT_FIELDS
} from "../../../resources/constants/fields";
import { 
	NETWORK_ERROR, 
	ERROR_DISPLAYING_RESULTS 
} from "../../../resources/constants/errors";
import {
	NO_MAILING_LIST_LABEL,
	DOCKET_ACTIONS_LABEL,
	SEARCH_RESULTS_LABEL,
	DATA_TABLE_TAB_LABEL,
	DEFAULT_FILENAME,
	NO_RESULTS_FOUND_TEXT,
	//EQUIPMENT_DESCRIPTION_COLUMN_MAX,
	ENVIRONMENTAL_COMMENTS_COLUMN_MAX,
	ACTIVE_CLASS_NAME,
	CLICK_TO_COLLAPSE_TEXT,
	CLICK_TO_EXPAND_TEXT,
	OPEN_RECORDATION_TITLE,
	RECORDATION_INFO_NO_PARTIES,
	RECORDATION_INFO_NO_CRS
} from "../../../resources/constants/ui";
import Loading from "../../../scenes/Loading";
import {Spinner} from "../../../resources/media/Spinner";
import {Pager} from "../../../scenes/Form/components/Pager";
import { 
    MAX_SEARCH_RESULTS, 
    RESPONSE_START_INDEX_FIELD, 
    RESPONSE_BATCH_SIZE_FIELD, 
    RESPONSE_TOTAL_COUNT_FIELD, 
    RESPONSE_DATA_FIELD, 
    RESPONSE_DATA_SUBSET_FIELD 
} from "../../../resources/constants/api";

import { 
	getMonthDayYearDate, 
	getLocalStringDate, 
	getDateTimeDisplay
} from "../../../resources/util/dateUtil";
import { 
	getSearchResultsByFields, 
	getDataAndTypeFromResponseAndType 
} from "../../../resources/util/search";


export const getHeadersByDataType = (dataType, isByDateSearch) => {
	return isByDateSearch
		? BY_DATE_RESULT_HEADERS[dataType]
		: RESULT_HEADERS[dataType];
};

export class SearchResultsGridHeader extends React.Component {
	render() {
		const dataType = SEARCH_FOR_ASSOCIATED_DATA_TYPE[this.props.searchFor];
		const headers = getHeadersByDataType(
			dataType,
			this.props.isByDateSearch
		);
		return (
			<thead>
				<tr>
					{headers.map((key, idx) => {
                        var className = '';
                        if(CENTERED_RESULT_COLUMNS.includes(key)){
                            className = 'centered';
                        }
						return <th className={className} key={`${idx}-${key}`}>{key}</th>;
					})}
				</tr>
			</thead>
		);
	}
}

// Used as search parameters for Docket click-ins
const getDocketNumObjectFromDataEntry = dataEntry => {
	var docketNums = {};
	if (dataEntry['docketId'])
		docketNums['docketId'] = dataEntry['docketId'];
	return docketNums;
};

const getDocketNumArrayFromDataEntry = dataEntry => {
	var docketNums = [];
	if (dataEntry[DOCKET_NUM_PART_ONE_NAME])
		docketNums.push(dataEntry[DOCKET_NUM_PART_ONE_NAME]);
	if (parseInt(dataEntry[DOCKET_NUM_PART_TWO_NAME]) > -1)
		docketNums.push(parseInt(dataEntry[DOCKET_NUM_PART_TWO_NAME]));
	if (parseInt(dataEntry[DOCKET_NUM_PART_THREE_NAME]) > -1)
		docketNums.push(parseInt(dataEntry[DOCKET_NUM_PART_THREE_NAME]));
	if (dataEntry[DOCKET_NUM_PART_FOUR_NAME])
		docketNums.push(dataEntry[DOCKET_NUM_PART_FOUR_NAME]);
	return docketNums;
};

// Used to display the Docket Number for a selected Docket
export const getDocketNumFromDataEntry = dataEntry => {
	var docketNums = getDocketNumArrayFromDataEntry(dataEntry);
	return docketNums.join("_");
};

const isValidFilenameInUrl = url => {
	return url.includes("/");
};

export const getFilenameFromUrl = url => {
	if (isValidFilenameInUrl(url)) {
		return decodeURIComponent(url
			.split("/")
			.pop());
	} else {
		return DEFAULT_FILENAME;
	}
};

const getAddressByDataEntry = (dataEntry, withContactInfo) => {
	var addressArray = [];
	if(dataEntry[FILED_BY_FIELD] && !withContactInfo){
		addressArray.push(dataEntry[FILED_BY_FIELD]);
	}
	if(dataEntry[ADDRESS_LINE_ONE_FIELD]){
		addressArray.push(dataEntry[ADDRESS_LINE_ONE_FIELD]);
	}
	if(dataEntry[ADDRESS_LINE_TWO_FIELD]){
		addressArray.push(dataEntry[ADDRESS_LINE_TWO_FIELD]);
	}
	
	var addressPostalArea = [];
	if(dataEntry[ADDRESS_CITY_FIELD]){
		addressPostalArea.push(`${dataEntry[ADDRESS_CITY_FIELD]},`);
	}
	if(dataEntry[ADDRESS_STATE_FIELD]){
		addressPostalArea.push(dataEntry[ADDRESS_STATE_FIELD]);
	}
	if(dataEntry[ADDRESS_ZIP_FIELD]){
		addressPostalArea.push(dataEntry[ADDRESS_ZIP_FIELD]);
	}
	addressArray.push(addressPostalArea.join(" "));

	if(dataEntry[ADDRESS_COUNTRY_FIELD]){
		addressArray.push(dataEntry[ADDRESS_COUNTRY_FIELD]);
	}
	if(dataEntry[ADDRESS_TEL_FIELD] && withContactInfo){
		addressArray.push(`Tel: ${dataEntry[ADDRESS_TEL_FIELD]}`);
	}
	if(dataEntry[ADDRESS_FAX_FIELD] && withContactInfo){
		addressArray.push(`Fax: ${dataEntry[ADDRESS_FAX_FIELD]}`);
	}
	return (
		addressArray.map((addressLine, idx) => {
			return (
				<React.Fragment key={`address-line-${idx}`}>{addressLine}<br/></React.Fragment>
			)
		})
	);
};

class RowDataByField extends React.Component {
	render() {
		var url;
		var className = '';
		if(CENTERED_RESULT_COLUMNS.includes(this.props.field)) {
			className = 'centered';
		}
		let redText = /*this.props.dataEntry[LATE_RELEASE_FIELD] ||*/
		(
			this.props.dataEntry.dataType === ALL_DOCUMENTS_DATA_TYPE &&
			this.props.dataEntry[DOCUMENT_TYPE_FIELD] === "Decision" &&
			ALL_DOCUMENTS_DECISION_RED_TEXT_FIELDS.includes(this.props.field)
		);
		if(redText) {
			className += getIsLateClass(redText);
		}
		const value = (() => {
			switch (this.props.field) {
				case DOCKET_NUM_FIELD:
					className = ' centered';
					if(redText) {
						className += getIsLateClass(redText);
					}
					var docketNum = getDocketNumFromDataEntry(this.props.dataEntry);
					if (this.props.dataEntry[DATA_TYPE_FIELD] === DOCKET_DATA_TYPE) {
						return (
							<Button
								variant="link"
								value={JSON.stringify(this.props.dataEntry)}
								onClick={this.props.handleDocketNumClickin}
								key={`docket-row-${this.props.row}-column-${this.props.column}`}
							>
								{docketNum}
							</Button>
						);
					} else {
						return docketNum;
					}
				case SERVICE_LIST_FIELD:
					className = 'centered';
					return (
						<Button
							variant="link"
							value={JSON.stringify(this.props.dataEntry)}
							onClick={this.props.handleGenerateServiceListClickIn}
							key={`service-list-row-${this.props.row}-column-${this.props.column}`}
							className={'service-list-btn'}
						>
							{SERVICE_LIST_TEXT}
						</Button>
					);
				case RECORDATION_NUM_FIELD:
					className = 'centered';
					return (
						<Button
							variant="link"
							title={OPEN_RECORDATION_TITLE}
							value={JSON.stringify(this.props.dataEntry)}
							onClick={this.props.handleGenerateRecordationClickIn}
							key={`service-list-row-${this.props.row}-column-${this.props.column}`}
							className={'service-list-btn'}
						>
							{this.props.dataEntry[RECORDATION_SUFFIX_NAME] ?
							`${this.props.dataEntry[this.props.field]}-${this.props.dataEntry[RECORDATION_SUFFIX_NAME]}`:
							this.props.dataEntry[this.props.field]}
						</Button>
					);
				case EQUIPMENT_DESCRIPTION_FIELD:
					className += ' equipment-desc-col';
					return (
						<div className="expandable-col">{this.props.dataEntry[this.props.field]}</div>
					);
				case RECORDATION_PARTY_NAME:
					className += ' party-col';
					return (
						<div className=" expandable-col">{this.props.dataEntry[this.props.field]}</div>
					);
				case RECORDATION_HAC_FIELD:
					className += ' centered';
					if(["YES", "TRUE"].includes(("" + this.props.dataEntry[this.props.field]).toUpperCase())){
						return "Yes";
					} else {
						return "";
					}
				case ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD:
					return this.props.dataEntry[ENVCOM_SUBMITTER_FIELD] || this.props.dataEntry[ENVCOM_RECIPIENT_FIELD] || "";
				case ENVCOM_COMMENTS_FIELD:
					let content = this.props.dataEntry[this.props.field];
					let coordinates = `${this.props.row}-${this.props.column}`;
					let button = null;
					if(content && content.length >= ENVIRONMENTAL_COMMENTS_COLUMN_MAX){
						if(this.props.expanded.includes(coordinates)){
							button = (
								<Button
									variant="link"
									name="less"
									value={`${this.props.row}-${this.props.column}`}
									className="column-more-btn"
									onClick={this.props.expandColumn}
								>
									{"Show Less"}
								</Button>
							);
						} else {
							button = (
								<Button
									variant="link"
									name="more"
									value={`${this.props.row}-${this.props.column}`}
									className="column-more-btn"
									onClick={this.props.expandColumn}
								>
									{"Show More"}
								</Button>
							);
							content = content.substring(0, ENVIRONMENTAL_COMMENTS_COLUMN_MAX).trim() + "...";
						}
						content = <>
							{content}
							{button}
						</>;
					}
					className += ' env-comment-col';
					return <div className="expandable-col">{content}</div>;
				case ADDRESS_FIELD:
					return getAddressByDataEntry(this.props.dataEntry, true);
				case ENVCOM_LOCATION_FIELD:
					var addressCity = this.props.dataEntry[ADDRESS_CITY_FIELD];
					var addressState = this.props.dataEntry[ADDRESS_STATE_FIELD];
					if (addressCity) {
						if (addressState) {
							return `${addressCity}, ${addressState}`;
						}
						return addressCity;
					}
					else if (addressState)
					{
						return addressState;
					} else {
						return "";
					}
				case ENVCOM_ORGANIZATION_FIELD: 
					className += ' organization-col';
					return this.props.dataEntry[ENVCOM_ORGANIZATION_FIELD];
				case DECISION_ATTACHMENT_FIELD:
					url = this.props.dataEntry[DECISION_ATTACHMENT_FIELD];
					return url ? <a href={url} target="_blank" rel="noopener noreferrer">{getFilenameFromUrl(url)}</a> : "";
				case FILING_ATTACHMENT_FIELD:
					url = this.props.dataEntry[FILING_ATTACHMENT_FIELD];
					return url ? <a href={url} target="_blank" rel="noopener noreferrer">{getFilenameFromUrl(url)}</a> : "";
				case RECORDATION_ATTACHMENT_FIELD:
					url = this.props.dataEntry[RECORDATION_ATTACHMENT_FIELD];
					return url ? <a href={url} target="_blank" rel="noopener noreferrer">{getFilenameFromUrl(url)}</a> : "";
				case ENVCOM_ATTACHMENT_FIELD:
					url = this.props.dataEntry[ENVCOM_ATTACHMENT_FIELD];
					return url ? <a href={url} target="_blank" rel="noopener noreferrer">{getFilenameFromUrl(url)}</a> : "";
				case ATTACHMENT_FIELD:
					url = this.props.dataEntry[ATTACHMENT_FIELD];
					return url ? <a href={url} target="_blank" rel="noopener noreferrer">{getFilenameFromUrl(url)}</a> : "";
				case DOCUMENT_NAME_FIELD:
					className += " word-break";
					url = this.props.dataEntry[RECORDATION_ATTACHMENT_FIELD];
					let title = this.props.dataEntry[this.props.field] || getFilenameFromUrl(url);
					return url ? <a href={url} target="_blank" rel="noopener noreferrer">{title}</a> : "";
				case RECORDATION_CROSS_REFERENCE_IDS:
					return this.props.dataEntry[RECORDATION_CROSS_REFERENCE_NUMBERS].split(",").join(", ");
				case SERVICE_DATE_FIELD:
					return getMonthDayYearDate(this.props.dataEntry[SERVICE_DATE_FIELD], true);
				case FILING_DATE_FIELD:
					return getMonthDayYearDate(this.props.dataEntry[FILING_DATE_FIELD], true);
				case OFFICIAL_FILING_DATE_FIELD:
					className += ' nowrap';
					if(this.props.dataEntry.dataType === RECORDATION_DATA_TYPE){
						return getDateTimeDisplay(this.props.dataEntry[OFFICIAL_FILING_DATE_FIELD]);
					} else {
						return getMonthDayYearDate(this.props.dataEntry[OFFICIAL_FILING_DATE_FIELD], true);
					}
				case ENVCOM_DATE_FIELD:
				case ENVCOM_DATE_RECEIVED_FIELD:
				case ENVCOM_DATE_OF_LETTER_FIELD:
					var dateVal = this.props.dataEntry[ENVCOM_DATE_RECEIVED_FIELD] || this.props.dataEntry[ENVCOM_DATE_OF_LETTER_FIELD] || "";
					return getMonthDayYearDate(dateVal, true);
				case ALL_DOCUMENTS_DATE_FIELD:
					return getMonthDayYearDate(this.props.dataEntry[ALL_DOCUMENTS_DATE_FIELD], true);
				default:
					if(typeof this.props.dataEntry[this.props.field] != "object") {
						return this.props.dataEntry[this.props.field] || "";
					}
			}
		})();
		if (value) {
			return <td className={className} key={`row-${this.props.row}-column-${this.props.column}`}>{value}</td>;
		} else {
			return <td key={`row-${this.props.row}-column-${this.props.column}`}></td>;
		}
	}
};

class SearchResultsRowData extends React.Component {
	render() {
		var dataTypeResultFields = this.props.isByDateSearch
			? BY_DATE_RESULT_FIELDS[this.props.dataEntry.dataType]
			: RESULT_FIELDS[this.props.dataEntry.dataType];
		return dataTypeResultFields.map((resultField, column) => {
			return (
				<React.Fragment key={`row-data-row-${this.props.row}-column-${column}`}>
					<RowDataByField
						dataEntry={this.props.dataEntry}
						field={resultField}
						row={this.props.row}
						column={column}
						handleDocketNumClickin={this.props.handleDocketNumClickin}
						handleGenerateServiceListClickIn={this.props.handleGenerateServiceListClickIn}
						handleGenerateRecordationClickIn={
							this.props.handleGenerateRecordationClickIn
						}
						expandColumn={this.props.expandColumn}
						expanded={this.props.expanded}
					/>
				</React.Fragment>
			)
		});
	}
}

class SearchResultsRow extends React.Component {
	render() {
		return (
			<tr key={`row-tr-${this.props.row}`}>
				<SearchResultsRowData
					dataEntry={this.props.dataEntry}
					isByDateSearch={this.props.isByDateSearch}
					row={this.props.row}
					handleDocketNumClickin={
						this.props.handleDocketNumClickin
					}
					handleGenerateServiceListClickIn={
						this.props.handleGenerateServiceListClickIn
					}
					handleGenerateRecordationClickIn={
						this.props.handleGenerateRecordationClickIn
					}
					expandColumn={this.props.expandColumn}
					expanded={this.props.expanded}
				/>
			</tr>
		);
	}
}

const getSearchResultRows = (
	dataSubset,
	byDate,
	docketClick,
	serviceListClick,
	recordationClick,
	expandColumn,
	expanded
) => {
	if (dataSubset) {
		return dataSubset.map((dataEntry, row) => {
			return (
				<SearchResultsRow
					key={`row-${row}`}
					row={row}
					dataEntry={dataEntry}
					isByDateSearch={byDate}
					handleDocketNumClickin={docketClick}
					handleGenerateServiceListClickIn={serviceListClick}
					handleGenerateRecordationClickIn={recordationClick}
					expandColumn={expandColumn}
					expanded={expanded}
				/>
			);
		});
	}
};

class SearchResultsRows extends React.Component {
	render() {
		return (
			<tbody>
				{getSearchResultRows(
					this.props.data.dataSubset,
					this.props.isByDateSearch,
					this.props.handleDocketNumClickin,
					this.props.handleGenerateServiceListClickIn,
					this.props.handleGenerateRecordationClickIn,
					this.props.expandColumn,
					this.props.expanded
				)}
			</tbody>
		);
	}
}

const getGridTitleText = ({ dataType, date, fields }) => {
	if(date){
		return `Results For ${getLocalStringDate(date)}:`;
	} else {
		if(dataType === RECORDATIONS_SEARCH_FOR_OPTION){
			return `${fields[RECORDATION_CATEGORY_FIELD]} ${dataType} ${SEARCH_RESULTS_LABEL}`;
		} else {
			return `${dataType} ${SEARCH_RESULTS_LABEL}`;
		}
	}
};

const isGridTitleVisible = ({ dataType, isDocketAssociatedSearch }) => {
	return (
		dataType !== SERVICE_LIST_SEARCH_FOR_OPTION && !isDocketAssociatedSearch
	);
};

const getCountsString = (searchFor, data) => {
	var dataType = searchFor;
	var totalCount = "";
	if(dataType === DOCKETS_SEARCH_FOR_OPTION) {
		dataType = DOCKETS_LABEL;
	}
	if(data && data.totalCount) {
		if(data.totalCount >= MAX_SEARCH_RESULTS) {
			totalCount = `${MAX_SEARCH_RESULTS.toLocaleString()}+`;
		}
		else {
			totalCount = data.totalCount.toLocaleString();
		}
		return `${totalCount} ${dataType}`;
	} else {
		return `0 ${dataType}`;
	}
}

const stringifyArray = (arrayToStringify) => {
	if(arrayToStringify.length){
		if(arrayToStringify.length > 1){
			return `${arrayToStringify.join(", ")}`;
		}
		else{
			return `${arrayToStringify[0]}`;
		}
	}
	return "";
}

class GridTitleBySearchType extends React.Component {
	render() {
		if (isGridTitleVisible(this.props)) {

			return (
				<React.Fragment>
					<div>
						{this.props.hideReturnBtn ? null : (
							<Button
								variant="primary"
								onClick={() => this.props.handleReturnToSearch(DOCKETS_SEARCH_FOR_OPTION)}
								className="return-btn return-btn--top"
							>
								{RETURN_TO_SEARCH_TEXT}
							</Button>
						)}
					</div>
					<div
						id="grid_title"
						className="d-flex justify-content-between grid-title"
					>
						<span>
							<h4 className="inline-block">
								{getGridTitleText(this.props)}
							</h4>
							<h5 className={"gray-text indent inline-block"}>{this.props.dataCounts}</h5>
						</span>
						{this.props.hideReturnBtn ? null : (
							<Button
								variant="primary"
								onClick={() => this.props.handleReturnToSearch(DOCKETS_SEARCH_FOR_OPTION)}
								className="return-btn return-btn--bottom"
							>
								{RETURN_TO_SEARCH_TEXT}
							</Button>
						)}
					</div>
				</React.Fragment>
			);
		} else {
			return null;
		}
	}
}

class DataTypeResultsGrid extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			id: `dataTypeResults-${props.dataType}`,
			index: props.index || 1,
			startIndex: 1,
			batchSize: 50,
			data: props.data,
			expanded:[]
		};
		this.scrollToResults = this.scrollToResults.bind(this);
		this.handleResponseData = this.handleResponseData.bind(this);
		this.setBatchSize = this.setBatchSize.bind(this);
		this.getDataForPage = this.getDataForPage.bind(this);
		this.isPagingInfoInData = this.isPagingInfoInData.bind(this);
		this.getCurrentPage = this.getCurrentPage.bind(this);
		this.getNextStartIndex = this.getNextStartIndex.bind(this);
		this.isLastPage = this.isLastPage.bind(this);
		this.isValidResponse = this.isValidResponse.bind(this);
		this.expandColumn = this.expandColumn.bind(this);
	}
	scrollToResults = () => {
		window.scrollTo(0, 0);
	};
	isPagingInfoInData = ({ data }) => {
		return (
			RESPONSE_START_INDEX_FIELD in data &&
			RESPONSE_BATCH_SIZE_FIELD in data &&
			RESPONSE_TOTAL_COUNT_FIELD in data
		);
	};
	getCurrentPage = ({ data }) => {
		return Math.trunc(
			(data[RESPONSE_START_INDEX_FIELD] +
				data[RESPONSE_BATCH_SIZE_FIELD]) /
				data[RESPONSE_BATCH_SIZE_FIELD]
		);
	};
	getNextStartIndex = ({ data }, pageNum, currentPage) => {
		return (
			data[RESPONSE_START_INDEX_FIELD] +
			data[RESPONSE_BATCH_SIZE_FIELD] * (pageNum - currentPage)
		);
	};
	isLastPage = ({ data }, nextStartIndex) => {
		return nextStartIndex > data[RESPONSE_TOTAL_COUNT_FIELD];
	};
	setBatchSize = async newBatchSize => {
		if (newBatchSize && Number(newBatchSize) > 0)
		{
			this.setState({batchSize: newBatchSize});
		}
		return true;
	};
	getDataForPage = async pageNum => {
		if (this.isPagingInfoInData(this.state)) {
			let currentPage = this.getCurrentPage(this.state);
			let nextStartIndex = this.getNextStartIndex(
				this.state,
				pageNum,
				currentPage
			);
			let searchParams = {};
			if (!this.isLastPage(this.state, nextStartIndex)) {
				this.setState({ startIndex: nextStartIndex });
				searchParams = {
					searchFor: this.props.dataType,
					fields: this.props.fields,
					startIndex: nextStartIndex,
					batchSize: this.state.batchSize
				};
				await getSearchResultsByFields(
					searchParams,
					this.handleResponseData
				);
				this.scrollToResults();
			}
		}
		return true;
	};
	isValidResponse = response => {
		return response.status === 200 && RESPONSE_DATA_FIELD in response;
	};
	handleResponseData = response => {
		if (this.isValidResponse(response)) {
			this.setState({ data: response.data });
		}
	};
	expandColumn = e => {
		if(e.target.name === 'more'){
			this.setState({expanded:[...this.state.expanded, e.target.value]})
		} else if(e.target.name === 'less'){
			let newExpanded = this.state.expanded.filter(
				(value)=>value!==e.target.value
			);
			this.setState({expanded:newExpanded});
		}
	};
	render() {
		const noResults = (
			<div key={`${this.state.id}-${this.state.index}`}>
				<Alert variant={"dark"}>{NO_RESULTS_FOUND_TEXT}</Alert>
			</div>
		);
		const errorResults = (
			<div key={`${this.state.id}-${this.state.index}`}>
				<Alert variant={"danger"}>{ERROR_DISPLAYING_RESULTS}</Alert>
			</div>
		);
		if (
			this.props.data &&
			this.props.data.dataSubset &&
			this.props.data.dataSubset.length
		) {
			return (
				<div
					id={this.state.id}
					key={`${this.state.id}-${this.state.index}`}
				>
					<div className={"table-container"}>
						<Pager
							keyVal={"pager-top"}
							current={1}
							showPageSize={this.state.id.endsWith(RECORDATIONS_SEARCH_FOR_OPTION)}
							setBatchSize={this.setBatchSize}
							getDataForPage={this.getDataForPage}
							totalCount={
								this.state.data[RESPONSE_TOTAL_COUNT_FIELD]
							}
							startIndex={
								this.state.data[RESPONSE_START_INDEX_FIELD]
							}
							batchSize={
								this.state.data[RESPONSE_BATCH_SIZE_FIELD]
							}
						/>
						<Table striped hover>
							<SearchResultsGridHeader
								data={this.state.data}
								searchFor={this.props.dataType}
								isByDateSearch={this.props.isByDateSearch}
							/>
							<SearchResultsRows
								data={this.state.data}
								searchFor={this.props.dataType}
								isByDateSearch={this.props.isByDateSearch}
								handleDocketNumClickin={
									this.props.handleDocketNumClickin
								}
								handleGenerateServiceListClickIn={
									this.props.handleGenerateServiceListClickIn
								}
								handleGenerateRecordationClickIn={
									this.props.handleGenerateRecordationClickIn
								}
								expandColumn={this.expandColumn}
								expanded={this.state.expanded}
							/>
						</Table>
						<Pager
							keyVal={"pager-bottom"}
							current={1}
							showPageSize={this.state.id.endsWith(RECORDATIONS_SEARCH_FOR_OPTION)}
							setBatchSize={this.setBatchSize}
							getDataForPage={this.getDataForPage}
							totalCount={
								this.state.data[RESPONSE_TOTAL_COUNT_FIELD]
							}
							startIndex={
								this.state.data[RESPONSE_START_INDEX_FIELD]
							}
							batchSize={
								this.state.data[RESPONSE_BATCH_SIZE_FIELD]
							}
						/>
					</div>
				</div>
			);
		} else if(this.props.data) {
			return noResults;
		}
		else{
			return errorResults;
		}
	}
}

export class SearchResultsGrid extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showSearch: this.props.showSearch || false
		};
	}
	render() {
		var elementsToRender = [];
		var dataCounts = [];
		var labels = [];
		if (this.state.showSearch && this.props.data) {
			for (let responseDataObject in this.props.data) {
				let label = "";
				if(this.props.searchFor === BY_DATE_SEARCH_FOR_OPTION){
					label = BY_DATE_LABELS[responseDataObject];
				} else {
					label = this.props.data[responseDataObject][
						SEARCH_FOR_NAME
					];
				}
				labels.push(
					this.props.isDocketAssociatedSearch
						? DOCKET_ASSOCIATED_LABELS[responseDataObject]
						: label
				);
				let data =
					RESPONSE_DATA_FIELD in this.props.data[responseDataObject]
						? this.props.data[responseDataObject][
								RESPONSE_DATA_FIELD
						  ]
						: null;
				dataCounts.push(getCountsString(label, data));
				
				elementsToRender.push(
					<React.Fragment key={`data-grid-${responseDataObject}`}>
						<DataTypeResultsGrid
							data={data}
							dataType={this.props.data[responseDataObject][SEARCH_FOR_NAME]}
							isByDateSearch={this.props.isByDateSearch}
							fields={this.props.fields}
							index={responseDataObject}
							searchFor={this.props.searchFor}
							handleDocketNumClickin={
								this.props.handleDocketNumClickin
							}
							handleGenerateServiceListClickIn={
								this.props.handleGenerateServiceListClickIn
							}
							handleGenerateRecordationClickIn={
								this.props.handleGenerateRecordationClickIn
							}
							handleReturnToSearch={this.props.handleReturnToSearch}
							handleMailingLabelsClick={
								this.props.handleMailingLabelsClick
							}
							isDocketAssociatedSearch={
								this.props.isDocketAssociatedSearch
							}
						/>
					</React.Fragment>
				);
			}
		}
		if (elementsToRender.length > 1) {
			return (
				<React.Fragment>
					{!!this.props.isDocketAssociatedSearch ? null : (
						<GridTitleBySearchType
							dataType={this.props.searchFor}
							lockedTo={this.props.lockedTo}
							fields={this.props.fields}
							dataCounts={stringifyArray(dataCounts)}
							hideReturnBtn={this.props.hideReturnBtn}
							isByDateSearch={this.props.isByDateSearch}
							date={this.props.fields.dateToView ? this.props.fields.dateToView : null}
							isDocketAssociatedSearch={
								this.props.isDocketAssociatedSearch
							}
							handleReturnToSearch={
								this.props.handleReturnToSearch
							}
							index={0}
						/>
					)}
					<UnderlinedTabs labels={labels}>
						{elementsToRender}
					</UnderlinedTabs>
				</React.Fragment>
			);
		} else {
			return (
				<React.Fragment>
					<GridTitleBySearchType
						dataType={this.props.searchFor}
						lockedTo={this.props.lockedTo}
						fields={this.props.fields}
						dataCounts={stringifyArray(dataCounts)}
						hideReturnBtn={this.props.hideReturnBtn}
						isByDateSearch={this.props.isByDateSearch}
						date={this.props.fields.dateToView ? this.props.fields.dateToView : null}
						isDocketAssociatedSearch={
							this.props.isDocketAssociatedSearch
						}
						handleReturnToSearch={this.props.handleReturnToSearch}
						index={0}
					/>
					{elementsToRender}
				</React.Fragment>
			);
		}
	}
}

class DocketAssociatedPageTitle extends React.Component {
	render() {
		const title = JSON.parse(this.props.docketClickIn).docketTitle;
		return (
			<React.Fragment>
				<div>
					<Button
						variant="primary"
						onClick={() => this.props.handleReturnToSearch(DOCKETS_SEARCH_FOR_OPTION)}
						className="return-btn return-btn--top"
					>
						{RETURN_TO_SEARCH_TEXT}
					</Button>
				</div>
				<div
					id="grid_title"
					className="d-flex justify-content-between grid-title"
				>
					<h3>{`${DOCKET_ACTIONS_LABEL} ${this.props.docketNum}`}</h3>
					
					<Button
						variant="primary"
						onClick={() => this.props.handleReturnToSearch(DOCKETS_SEARCH_FOR_OPTION)}
						className="return-btn return-btn--bottom"
					>
						{RETURN_TO_SEARCH_TEXT}
					</Button>
					
				</div>
				<h4 className={"indent italic"}>{`${title}`}</h4>
				<h5 className={"gray-text indent"}>
					{this.props.dataCounts}
				</h5>
			</React.Fragment>
		);
	}
}

export class DocketAssociatedPage extends React.Component {
	constructor(props) {
		super(props);
		this.docketNum = getDocketNumFromDataEntry(
			JSON.parse(this.props.docketClickIn)
		);
		this.docketNumFields = getDocketNumObjectFromDataEntry(
			JSON.parse(this.props.docketClickIn)
		);
		this.state = {
			associatedDecisionsData: null,
			decisionsCount: null,
			associatedFilingsData: null,
			filingsCount: null,
			dataCounts: null,
			data: null,
			networkError: false
		};
		this.handleSaveAssociatedData = this.handleSaveAssociatedData.bind(
			this
		);
	}
	handleSaveAssociatedData = responses => {
		var responseData = [];
		var networkError = false;
		var dataCounts = [];
		for (var responseObject in responses) {
			var searchForData = getDataAndTypeFromResponseAndType(responses[responseObject]);
			if(searchForData){
				responseData.push(searchForData);
				dataCounts.push(getCountsString(searchForData.searchFor, searchForData.data));
			} else {
				responseData.push({
					searchFor: responses[responseObject][SEARCH_FOR_NAME],
					error:NETWORK_ERROR});
			}
		}
		this.setState({
			dataCounts: dataCounts,
			data: responseData,
			networkError: networkError
		});
	};
	componentDidMount = async () => {
		const decisionsSearchParams = {
			searchFor: DECISIONS_SEARCH_FOR_OPTION,
			fields: this.docketNumFields
		};
		const filingsSearchParams = {
			searchFor: FILINGS_SEARCH_FOR_OPTION,
			fields: this.docketNumFields
		};
		const environmentalCommentsSearchParams = {
			searchFor: ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION,
			fields: this.docketNumFields
		};
		const allDocumentsSearchParams = {
			searchFor: ALL_DOCUMENTS_SEARCH_FOR_OPTION,
			fields: this.docketNumFields
		};
		var decisionResponse = await getSearchResultsByFields(
			decisionsSearchParams
		);
		var filingResponse = await getSearchResultsByFields(
			filingsSearchParams
		);
		var environmentalCommentsResponse = await getSearchResultsByFields(
			environmentalCommentsSearchParams
		);
		var allDocumentsResponse = await getSearchResultsByFields(
			allDocumentsSearchParams
		);
		this.handleSaveAssociatedData(
			[
				...allDocumentsResponse,
				...decisionResponse,
				...filingResponse,
				...environmentalCommentsResponse
			]
		);
	};

	render() {
		if(this.state.data){
			return (
				<React.Fragment>
					<DocketAssociatedPageTitle
						dataCounts={stringifyArray(this.state.dataCounts)}
						docketNum={this.docketNum}
						docketClickIn={this.props.docketClickIn}
						handleReturnToSearch={this.props.handleReturnToSearch}
					/>
					<br />
					<SearchResultsGrid
						showSearch={true}
						data={this.state.data}
						searchFor={this.state.searchFor}
						fields={this.docketNumFields}
						handleReturnToSearch={this.props.handleReturnToSearch}
						isDocketAssociatedSearch={true}
					/>
				</React.Fragment>
			);
		}
		else{
			return <Loading/>
		}
	}
}

class ServiceListPageTitle extends React.Component {
	render() {
		const serviceListClickin = JSON.parse(this.props.serviceListClickIn);
		const docketNums = getDocketNumFromDataEntry(serviceListClickin);
		const title = serviceListClickin.docketTitle;
		return (
			<React.Fragment>
				<div>
					<Button
						variant="primary"
						onClick={this.props.handleReturnToSearch}
						className="return-btn return-btn--top"
					>
						{RETURN_TO_SEARCH_TEXT}
					</Button>
				</div>
				<div
					id="grid_title"
					className="d-flex justify-content-between grid-title"
				>
					<h3>{DOCKET_NUM_LABEL}{docketNums}</h3>
					<Button
						variant="primary"
						onClick={this.props.handleReturnToSearch}
						className="return-btn return-btn--bottom"
					>
						{RETURN_TO_SEARCH_TEXT}
					</Button>
				</div>
				<h4 className={"indent italic"}>{title}</h4>
				
			</React.Fragment>
		);
	}
}

class UnderlinedTabs extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeIndex: 0,
			tabPages: []
		};
		this.changeActiveTo = this.changeActiveTo.bind(this);
		this.getTabHeader = this.getTabHeader.bind(this);
		this.getTabContent = this.getTabContent.bind(this);
	}
	changeActiveTo(activeIndex) {
		this.setState({ activeIndex });
	}
	getTabHeader() {
		return this.props.children.map((child, index) => {
			
			var hasChildCount = child.props.data && "totalCount" in child.props.data;
			var hasChildOfChildCount = "props" in child && 
				"children" in child.props && 
				child.props.children && 
				"props" in child.props.children && 
				child.props.children.props &&
				"data" in child.props.children.props && 
				child.props.children.props.data &&
				"totalCount" in child.props.children.props.data;
			var childCount = 0;
			if(hasChildCount){
				childCount = child.props.data.totalCount;
			} else if(hasChildOfChildCount){
				childCount = child.props.children.props.data.totalCount;
			}
			
			var countBadge = childCount > 0
				? <span className="badge badge-primary">{Number(childCount).toLocaleString()}</span> 
				: <span className="badge badge-secondary">{Number(childCount).toLocaleString()}</span>;
			let label =
				index < this.props.labels.length
					? this.props.labels[index]
					: `Tab ${index + 1}`;
			let hideBadge = label === MAILING_LABELS_TEXT;
			return (
				<Button
					key={`button-tab-${index}`}
					className={"mailing-labels-button-tab"}
					variant={"link"}
					disabled={this.state.activeIndex === index}
					onClick={() => this.changeActiveTo(index)}
				>
					<strong>{label}</strong>{hideBadge ? null : countBadge}
				</Button>
			);
		});
	}
	getTabContent() {
		return (
			<React.Fragment>
				{this.props.children.map((child, index) => (
					<div
						key={`tab-content-${index}`}
						id={`tab-content-${index}`}
						className={
							this.state.activeIndex === index ? "" : "hide"
						}
					>
						{child}
					</div>
				))}
			</React.Fragment>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className={"mailing-labels-button"}>
					{this.getTabHeader()}
				</div>
				<div>{this.getTabContent()}</div>
			</React.Fragment>
		);
	}
}

class MailingList extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			data: null,
			loading: false
		}
		this.getDataForPage = this.getDataForPage.bind(this);
		this.isValidResponse = this.isValidResponse.bind(this);
		this.handleResponseData = this.handleResponseData.bind(this);
	}
	componentDidMount = () => {
		this.getDataForPage();
	}
	getDataForPage = async () => {
		this.setState({loading: true});
		let searchParams = {};
		searchParams = {
			searchFor: this.props.dataType,
			fields: this.props.fields,
			batchSize: MAX_SEARCH_LIMIT
		};
		await getSearchResultsByFields(
			searchParams,
			this.handleResponseData
		);
		this.setState({loading: false});
		return true;
	};
	isValidResponse = response => {
		return response.status === 200 && RESPONSE_DATA_FIELD in response;
	};
	handleResponseData = response => {
		if (this.isValidResponse(response)) {
			this.setState({ data: response.data });
		}
	};
	render() {
		if(this.state.loading){
			return <div className="center"><br/><Spinner/></div>
		} else {
			if (
				this.state.data &&
				this.state.data.dataSubset &&
				this.state.data.dataSubset.length
			) {
				return <table><tbody>
					{this.state.data[RESPONSE_DATA_SUBSET_FIELD].map(
						(dataEntry, idx) => {
							return (
								<React.Fragment key={`mailing-list-row-${idx}`}>
								<tr
									className={"top-margin"}
									valign="TOP"
								>
									<td
										key={`mailing-list-row-${idx}-party-type`}
									>
										{`${dataEntry[PARTY_TYPE_FIELD]}: `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									</td>
									<td
										key={`mailing-list-row-${idx}-address`}
									>
										{getAddressByDataEntry(dataEntry, false)}
										<br/>
									</td>
								</tr>
								<tr></tr>
								</React.Fragment>
							);
						}
					)}
				</tbody></table>
			} else {
				return <p>{NO_MAILING_LIST_LABEL}</p>;
			}
		}
	}
}

export class ServiceListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			docketId: JSON.parse(this.props.serviceListClickIn).docketId,
			serviceListData: null,
			isMailingLabels: false,
			networkError: false,
			dataCounts: null
		};
		this.handleSaveServiceList = this.handleSaveServiceList.bind(this);
		this.handleMailingLabelsClick = this.handleMailingLabelsClick.bind(
			this
		);
	}
	handleSaveServiceList = responses => {
		var responseData = [];
		var networkError = false;
		var dataCounts = [];
		for (var responseObject in responses) {
			var searchForData = getDataAndTypeFromResponseAndType(responses[responseObject]);
			if(searchForData){
				responseData.push(searchForData);
				dataCounts.push(getCountsString(PARTIES_LABEL, searchForData.data));
			} else {
				responseData.push({
					searchFor: responses[responseObject][SEARCH_FOR_NAME],
					error:NETWORK_ERROR});
			}
		}
		this.setState({
			dataCounts: dataCounts,
			serviceListData: responseData,
			networkError: networkError
		});
	};

	handleMailingLabelsClick = () => {
		this.setState({ isMailingLabels: !this.state.isMailingLabels });
	};

	componentDidMount = async () => {
		const serviceListSearchParams = {
			searchFor: SERVICE_LIST_SEARCH_FOR_OPTION,
			fields: {
				docketId: this.state.docketId
			}
		};
		let serviceListResponse = await getSearchResultsByFields(
			serviceListSearchParams
		);

		this.handleSaveServiceList(serviceListResponse);
	};

	render() {
		if (this.state.serviceListData) {
			return (
				<React.Fragment>
					<ServiceListPageTitle
						serviceListClickIn={this.props.serviceListClickIn}
						handleReturnToSearch={() => this.props.handleReturnToSearch(DOCKETS_SEARCH_FOR_OPTION)}
					/>
					<div className={"d-flex justify-content-left grid-title"}>
						<h4>{SERVICE_LIST_HEADER}</h4>
						<h5 className={"gray-text indent vert-bottom"}>
							{stringifyArray(this.state.dataCounts)}
						</h5>
					</div>
					<UnderlinedTabs
						labels={[DATA_TABLE_TAB_LABEL, MAILING_LABELS_TEXT]}
					>
						<DataTypeResultsGrid
							data={this.state.serviceListData[0].data}
							dataType={
								this.state.serviceListData[0][SEARCH_FOR_NAME]
							}
							fields={{ docketId: this.state.docketId }}
							searchFor={this.state.serviceListData[0][SEARCH_FOR_NAME]}
						/>
						<MailingList
							dataType={
								this.state.serviceListData[0][SEARCH_FOR_NAME]
							}
							fields={{ docketId: this.state.docketId }}
							searchFor={this.state.serviceListData[0][SEARCH_FOR_NAME]}
						/>
					</UnderlinedTabs>
				</React.Fragment>
			);
		} else {
			return <Loading/>;
		}
	}
}

export class RecordationInformationPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			recordationData: null,
			recordationPartiesData: null,
			networkError: null,
			dataCounts: null
		};
		this.handleSaveRecordationData = this.handleSaveRecordationData.bind(this);
		this.updateRecordation = this.updateRecordation.bind(this);
		this.searchRecordationId = this.searchRecordationId.bind(this);
	}
	handleSaveRecordationData = (recordationResponse, recordationPartiesResponse) => {
		var recordationData = null;
		var networkError = null;
		for (var recIndex in recordationResponse) {
			var validSearchForData = getDataAndTypeFromResponseAndType(recordationResponse[recIndex]);
			if(validSearchForData){
				if(validSearchForData[RESPONSE_DATA_FIELD][RESPONSE_DATA_SUBSET_FIELD].length){
					recordationData = validSearchForData[RESPONSE_DATA_FIELD][RESPONSE_DATA_SUBSET_FIELD][0];
				} else {
					networkError = "Error Loading Recordation";
				}
			} else {
				networkError = "Error Loading Recordation";
			}
		}
		var recordationParties = [];
		var dataCounts = [];
		for (var partyIndex in recordationPartiesResponse) {
			var searchForData = getDataAndTypeFromResponseAndType(recordationPartiesResponse[partyIndex]);
			if(searchForData && searchForData.data && searchForData.data.dataSubset && searchForData.data.dataSubset.length){
				if(searchForData.data.dataSubset[0].dataType === "recordationParty"){
					recordationParties = [...searchForData.data.dataSubset];
					dataCounts.push(getCountsString(PARTIES_LABEL, searchForData.data));
				}
				else {
					networkError = "Error Loading Recordation";
				}
			}
		}
		this.setState({
			dataCounts: dataCounts,
			recordationData: recordationData,
			recordationParties: recordationParties,
			networkError: networkError
		});
	};

	searchRecordationId = async recordationId => {
		this.setState({recordationData:null});
		const recordationSearchParams = {
			searchFor: RECORDATIONS_SEARCH_FOR_OPTION,
			fields: {
				recordationId: Number(recordationId)
			}
		};
		const recordationPartiesSearchParams = {
			searchFor: RECORDATION_PARTIES_SEARCH_FOR_OPTION,
			fields: {
				recordationId: Number(recordationId)
			}
		};
		let recordationResponse = await getSearchResultsByFields(
			recordationSearchParams
		);
		let recordationPartiesResponse = await getSearchResultsByFields(
			recordationPartiesSearchParams
		);
		this.handleSaveRecordationData(recordationResponse, recordationPartiesResponse);
	}

	updateRecordation = recordationId => {
		this.searchRecordationId(recordationId);
	}

	componentDidMount = () => {
		this.searchRecordationId(JSON.parse(this.props.recordationClickIn).recordationId);
	};

	render() {
		window.scrollTo(0,0);
		if(this.state.networkError){
			throw this.state.networkError;
		} else {
			if (this.state.recordationData) {
				var categoryTitle = this.state.recordationData[RECORDATION_CATEGORY_FIELD].toLowerCase();
				categoryTitle = categoryTitle.replace(categoryTitle[0], categoryTitle[0].toUpperCase());
				return (
					<React.Fragment>
						<ReturnToSearch
							handleReturnToSearch={() => this.props.handleReturnToSearch(RECORDATIONS_SEARCH_FOR_OPTION)}
							lockedTo={this.props.lockedTo}
							title={`Surface Transportation Board ${categoryTitle} Recordations`}
						/>
						<CollapseSection title={"Recordation Information"}>
							{getRecordationInfo(this.state.recordationData)}
						</CollapseSection>
							
						<CollapseSection title={"Equipment Description"}>
							{getRecordationEquipmentDesc(this.state.recordationData)}
						</CollapseSection>

						<CollapseSection title={"Cross References"}>
							{getRecordationCrossReferences(this.state.recordationData, this.updateRecordation)}
						</CollapseSection>
						<CollapseSection title={"Recordation Parties"}>
							{getRecordationParties(this.state.recordationParties)}
						</CollapseSection>
					</React.Fragment>
				);
			} else {
				return <Loading/>;
			}
		}
	}
}

class CollapseSection extends React.Component {
	constructor(props){
		super(props);
		this.state={
			expanded: props.expanded || true
		}
		this.expandSection = this.expandSection.bind(this);
	}

	expandSection() {
		if (this.state.expanded) {
			this.setState({ expanded: false });
		} else {
			this.setState({ expanded: true });
		}
	}

	render() {
		var active = this.state.expanded ? ACTIVE_CLASS_NAME : "";
		var titleText = this.state.expanded
			? CLICK_TO_COLLAPSE_TEXT
			: CLICK_TO_EXPAND_TEXT;
		return (
			<div>
				<Button
					variant="link"
					onClick={this.expandSection}
					title={titleText}
					className={"collapse-btn"}
				>
					<div className="recordation-section-title">
						<strong>
							<img
								src={chevronDown}
								alt={titleText}
								className={`collapse-chevron ${active}`}
							/>
							{this.props.title}
						</strong>
					</div>
				</Button>
				{this.state.expanded ?
					<div className="recordation-box">
						{this.props.children}
					</div> :
				null}
			</div>
		)
	}
}

const getRecordationInfo = recordation => {
	var recNoString = recordation[RECORDATION_NUM_FIELD];
	if(recordation[RECORDATION_SUFFIX_NAME])
		recNoString += `-${recordation[RECORDATION_SUFFIX_NAME]}`;
	
	var recordationNo = (
		<div className="recordation-info-data">{recNoString}</div>
	);
	var recordationDocDate = (
		<div className="recordation-info-data">
			{getMonthDayYearDate(recordation[RECORDATION_DATE_OF_AGREEMENT_FIELD], true)}
		</div>
	);
	var recordationFilingDate = (
		<div className="recordation-info-data">
			{getDateTimeDisplay(recordation[OFFICIAL_FILING_DATE_FIELD])}
		</div>
	);
	var recordationType = (
		<div className="recordation-info-data">
			{recordation[RECORDATION_TYPE_OF_AGREEMENT_FIELD]}
		</div>
	);
	var recordationHac = (
		<div className="recordation-info-data">
			{recordation[RECORDATION_HAC_FIELD]}
		</div>
	);
	
	var orderedInfo = [
		[
			{labelSize:6, label: RECORDATION_NUMBER_LABEL, field: recordationNo},
			{labelSize:6, label: RECORDATION_TYPE_LABEL, field: recordationType}
		],[
			{labelSize:6, label: RECORDATION_DATE_OF_AGREEMENT_LABEL, field: recordationDocDate},
			{labelSize:6, label: OFFICIAL_FILING_DATE_LABEL, field: recordationFilingDate}
		]
	];
	var recordationField = {labelSize:6, label: RECORDATION_HAC_LABEL, field: ("" + recordationHac).toUpperCase() === "TRUE" ? "Yes" : ("" + recordationHac).toUpperCase() === "FALSE" ? "No" : recordationHac};
	return (
		<Row>
			{orderedInfo.map((row, rowIdx) => (
				<Col lg={6} key={`row-${rowIdx}`}> {row.map((field, index) => (
					<Row key={`${field.label}-${index}`}>
						<Col lg={field.labelSize} md={field.labelSize-2} sm={field.labelSize} className={"recordation-info-col"}>
							<div className={"recordation-info-label vert-center"}>{field.label}</div>
						</Col>
						<Col lg={12-field.labelSize} md={10-field.labelSize} sm={12-field.labelSize} className={"recordation-info-col"}>
							<div className="vert-center">{field.field}</div>
						</Col>
					</Row>
					))}
				</Col>
			))}
			<Col lg={12}>
				<Row key={recordationField.label}>
					<Col lg={recordationField.labelSize} md={recordationField.labelSize-2} sm={recordationField.labelSize} className={"recordation-info-col"}>
						<div className={"recordation-info-label vert-center"}>{recordationField.label}</div>
					</Col>
					<Col lg={12-recordationField.labelSize} md={10-recordationField.labelSize} sm={12-recordationField.labelSize} className={"recordation-info-col"}>
						<div className="vert-center">{recordationField.field}</div>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}

const getRecordationEquipmentDesc = recordation => {
	var recordationEquipmentDesc = (
		<div className="equipment-description-data">
			{recordation[RECORDATION_EQUIPMENT_DESCRIPTION_FIELD]}
		</div>
	);
	var recordationDocumentLink = recordation[RECORDATION_ATTACHMENT_FIELD] ? (
		<div className="recordation-document-link">
			<a href={recordation[RECORDATION_ATTACHMENT_FIELD]}>
				<img src={pdf} alt="PDF" className="pdf-img"/>
				{recordation[DOCUMENT_NAME_FIELD] || getFilenameFromUrl(recordation[RECORDATION_ATTACHMENT_FIELD])}
			</a>
		</div>
	) : null;
	var labelSize = 3;
	
	return (
		<Row>
			<Col lg={labelSize}>
				<div className={"equipment-description-label"}>{RECORDATION_EQUIPMENT_DESCRIPTION_LABEL}</div>
			</Col>
			<Col lg={12-labelSize}>
				{recordationEquipmentDesc}
			</Col>
			<Col lg={labelSize}>
				<div className={"equipment-description-label"}>{RECORDATION_DOCUMENT_LABEL}</div>
			</Col>
			<Col lg={12-labelSize}>
				{recordationDocumentLink}
			</Col>
		</Row>
	);
}

const getRecordationCrossReferences = (recordation, updateRecordation) => {
	if(recordation[RECORDATION_CROSS_REFERENCE_NUMBERS].length && recordation[RECORDATION_CROSS_REFERENCE_IDS].length){
		var crNumbers = recordation[RECORDATION_CROSS_REFERENCE_NUMBERS].split(',');
		var crIds = recordation[RECORDATION_CROSS_REFERENCE_IDS].split(',');
		return (
			<Row>
				{crNumbers.map((number, index) => (
				<Col xs={3} sm={3} md={2} lg={1} key={`${number}-${index}`}>
					<div>
						<Button
							variant="link"
							title={OPEN_RECORDATION_TITLE}
							value={JSON.stringify(recordation)}
							onClick={() => updateRecordation(crIds[index])}
							key={`cross-reference-${index}`}
							className={'service-list-btn'}
						>
							{number}
						</Button>
					</div>
				</Col>
				))}
			</Row>
		);
	} else {
		return (
			<Row>
				<Col key={`noreferences`}>
					{RECORDATION_INFO_NO_CRS}
				</Col>
			</Row>
		);
	}
}

const getRecordationParties = parties => {
	var submitterParties = [];
	var partyList = [];
	
	parties.map(party => {
		if(Number(party[RECORDATION_PARTY_ID_FIELD]) === 0){
			submitterParties.push(
				<div className="recordation-party">
					<div><strong>{SUBMITTER_HEADER}</strong></div>
					<div>{party[SUBMITTER_FIELD]}</div>
					<div>{party[COMPANY_FIELD]}</div>
					<div>{party[ADDRESS_LINE_ONE_FIELD]}</div>
					<div>{party[ADDRESS_LINE_TWO_FIELD]}</div>
					<div>{(party[ADDRESS_CITY_FIELD] ? `${party[ADDRESS_CITY_FIELD]}, ` : "") + `${party[ADDRESS_STATE_FIELD]} ${party[ADDRESS_ZIP_FIELD]}`}</div>
					<div>{party[ADDRESS_COUNTRY_FIELD]}</div>
				</div>
			);
		} else {
			partyList.push(
				<div className="recordation-party">
					<strong>
						{party[PARTY_TYPE_FIELD] ?
						<div>{party[PARTY_TYPE_FIELD]}</div> :
						<div>{party[OTHER_PARTY_TYPE_FIELD]}</div>}
					</strong>
					<div>{party[COMPANY_FIELD]}</div>
					<div>{party[ADDRESS_LINE_ONE_FIELD]}</div>
					<div>{party[ADDRESS_LINE_TWO_FIELD]}</div>
					<div>{(party[ADDRESS_CITY_FIELD] ? `${party[ADDRESS_CITY_FIELD]}, ` : "") + `${party[ADDRESS_STATE_FIELD]} ${party[ADDRESS_ZIP_FIELD]}`}</div>
					<div>{party[ADDRESS_COUNTRY_FIELD]}</div>
				</div>
			);
		}
		return null;
	});
	
	var orderedParties = [...submitterParties, ...partyList];
	if(orderedParties.length){
		return (
			<Row>
				{orderedParties.map((partyJSX, index) => (
					<Col md={6} lg={4} key={`party-${index}`}>
						{partyJSX}
					</Col>
				))}
			</Row>
		);
	} else {
		return (
			<Row>
				<Col key={`noparty`}>
					{RECORDATION_INFO_NO_PARTIES}
				</Col>
			</Row>
		);
	}
	
}

class ReturnToSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
					<div>
						<Button
							variant="primary"
							onClick={() => this.props.handleReturnToSearch(RECORDATIONS_SEARCH_FOR_OPTION)}
							className="return-btn return-btn--top"
						>
							{this.props.lockedTo ? RETURN_TO_RESULTS_TEXT : RETURN_TO_SEARCH_TEXT}
						</Button>
					</div>
					<div
						id="grid_title"
						className="d-flex justify-content-between grid-title"
					>
						<span>
							<h4 className="inline-block">
								{this.props.title}
							</h4>
						</span>
						<Button
							variant="primary"
							onClick={() => this.props.handleReturnToSearch(RECORDATIONS_SEARCH_FOR_OPTION)}
							className="return-btn return-btn--bottom"
						>
							{this.props.lockedTo ? RETURN_TO_RESULTS_TEXT : RETURN_TO_SEARCH_TEXT}
						</Button>
					</div>
			</React.Fragment>
		);
	}
}
